import React, { FC } from 'react'
import { Flex, Link, Box, Text } from '@chakra-ui/react'
import { Link as RouterLink, useHistory } from 'react-router-dom'
import { use100vh } from 'react-div-100vh'
import { ROUTES } from '../../contants'

type Props = {
  previous?: boolean
}

const AuthLayout: FC<Props> = ({ children, previous }) => {
  const height = use100vh()
  const history = useHistory()

  return (
    <Flex
      pos="relative"
      flexDir="column"
      justifyContent="space-between"
      maxW={{ md: '480px' }}
      w="full"
      mx="auto"
      p="2.4rem"
      h={height || undefined}>
      <Box>
        {previous && (
          <Text
            cursor="pointer"
            mb="2rem"
            onClick={() => history.goBack()}
            _hover={{ border: 'none', outline: 'none' }}
            _active={{ border: 'none', outline: 'none' }}
            _focus={{ border: 'none', outline: 'none' }}>
            <svg
              width="15"
              height="14"
              viewBox="0 0 15 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3.4451 6.10003H14.3996V7.89997H3.4451L8.27256 12.7274L7 14L0 7L7 0L8.27256 1.27256L3.4451 6.10003Z"
                fill="#2E279D"
              />
            </svg>
          </Text>
        )}
        <Link
          as={RouterLink}
          to={ROUTES.base}
          _hover={{ border: 'none', outline: 'none' }}
          _active={{ border: 'none', outline: 'none' }}
          _focus={{ border: 'none', outline: 'none' }}>
          <svg
            width="44"
            height="35"
            viewBox="0 0 44 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M18.0016 11.7404C18.0016 12.9933 19.383 13.759 20.4516 13.0983L22.7288 11.6904C23.3177 11.3736 23.6997 11.0489 23.8748 10.7162C24.0658 10.3677 24.1135 10.0588 24.018 9.78955C23.9385 9.50441 23.7315 9.27472 23.3973 9.10048C22.8529 8.77541 22.2991 8.30276 22.2991 7.67045V1.59817C22.2991 0.715528 23.0173 0 23.9032 0H39.9619C40.8478 0 41.566 0.715527 41.566 1.59817V7.21717C41.566 8.09982 40.8437 8.79568 39.9667 8.92077C39.5842 8.97533 39.2259 9.05107 38.892 9.148C38.128 9.35393 37.2765 9.7341 36.3374 10.2885L32.964 12.2673C32.1315 12.7555 31.9179 13.8607 32.5088 14.6221L39.4173 23.5234C39.7038 23.9353 39.9823 24.3075 40.2529 24.6402C40.5394 24.957 40.8418 25.2342 41.1601 25.4718C41.4944 25.6936 41.8764 25.8678 42.3061 25.9946C42.325 25.9999 42.3441 26.0052 42.3633 26.0103C43.2191 26.2389 43.9535 26.9002 43.9535 27.7828V33.4018C43.9535 34.2845 43.2353 35 42.3493 35H23.9032C23.0173 35 22.2991 34.2845 22.2991 33.4018V27.7044C22.2991 26.8651 23.0668 26.3474 23.7793 25.8995C24.0976 25.7094 24.2966 25.4797 24.3762 25.2105C24.4557 24.9253 24.4478 24.656 24.3523 24.4026C24.2568 24.1333 24.1613 23.9353 24.0658 23.8086L21.5092 20.628C21.0051 20.001 20.1122 19.8442 19.4233 20.2618L18.7719 20.6566C18.2936 20.9466 18.0016 21.4641 18.0016 22.0219V23.8086C18.0016 24.2363 18.0175 24.5927 18.0493 24.8778C18.0812 25.1629 18.1846 25.4085 18.3597 25.6144C18.5348 25.8045 18.7895 25.947 19.1237 26.0421C19.8802 26.2474 20.5323 26.8179 20.5323 27.5991V33.4018C20.5323 34.2845 19.8141 35 18.9282 35H1.60414C0.718199 35 0 34.2845 0 33.4018V27.7828C0 26.9002 0.723377 26.213 1.59946 26.0816C2.19643 25.9921 2.66602 25.8443 3.00822 25.6382C3.61305 25.258 3.91547 24.5531 3.91547 23.5234V11.5003C3.91547 10.4549 3.61305 9.74994 3.00822 9.38561C2.66594 9.17046 2.19621 9.01618 1.59904 8.92279C0.723814 8.78592 0 8.09982 0 7.21717V1.59817C0 0.715528 0.718199 0 1.60414 0H18.9282C19.8141 0 20.5323 0.715527 20.5323 1.59817V7.40089C20.5323 8.18207 19.8802 8.75257 19.1237 8.95791C18.7895 9.05295 18.5348 9.20344 18.3597 9.40937C18.1846 9.59946 18.0812 9.84499 18.0493 10.146C18.0175 10.4311 18.0016 10.7875 18.0016 11.2152V11.7404Z"
              fill="#4D80E4"
            />
          </svg>
        </Link>
      </Box>
      {children}
    </Flex>
  )
}

export { AuthLayout }
